export default {
  methods: {
    buildEventProductData(product) {
      const data = { ...product };
      if (this.$route.query.query_id) {
        _.set(data, 'metadata.queryId', this.$route.query.query_id);
        if (this.$route.query.position) {
          _.set(data, 'metadata.position', parseInt(this.$route.query.position, 10));
        }
      }
      return data;
    },
    emitProductEvent(eventName, payload) {
      // product events in product page
      if ([
        'product-viewed',
        'product-favorite',
        'product-similar-search',
        'product-sample-download',
        'product-licensed',
        'product-downloaded',
      ].includes(eventName)) {
        if (_.has(payload, 'product')) {
          payload.product = this.buildEventProductData(payload.product);
        }
        this.$bus.$emit(eventName, payload);
      }
    },
  },
};
